import React from 'react';
import { Document } from '../../../../store/summaryTest/types';
import { Text } from '../../../../components/Typography';
import styles from './DocumentItem.module.scss';
import Checkbox from '../../../../components/UI/Checkbox';

interface DocumentItemProps {
  document: Document;
  isSelected: boolean;
  isPending?: boolean;
  onToggle: (documentId: string) => void;
}

const DocumentItem: React.FC<DocumentItemProps> = ({
  document,
  isSelected,
  isPending = false,
  onToggle,
}) => {
  const handleToggle = () => {
    if (!isPending) {
      onToggle(document.id);
    }
  };

  const labelContent = (
    <div className={styles.content}>
      <Text size="base" weight="semibold" className={styles.title}>
        {document.name}
      </Text>
      <Text size="small" color="neutral-500" className={styles.meta}>
        {document.type} • {new Date(document.published_at || '').toLocaleDateString()}
        {document.fiscal_year && ` • FY ${document.fiscal_year}`}
        {document.fiscal_quarter && ` Q${document.fiscal_quarter}`}
      </Text>
      {isPending && (
        <Text size="small" color="neutral-500" className={styles.pendingText}>
          Loading...
        </Text>
      )}
    </div>
  );

  return (
    <div className={styles.container}>
      <Checkbox
        label={labelContent}
        checked={isSelected}
        onChange={handleToggle}
        disabled={isPending}
        className={isPending ? styles.pending : ''}
      />
    </div>
  );
};

export default DocumentItem;
